var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-container__wrap"},[_c('div',{staticClass:"side-container__title"},[_vm._t("title")],2),(_vm.hasContent)?_c('div',{staticClass:"side-container"},[_c('span',{staticClass:"side-container__indicator",style:({background: _vm.indicator})}),_c('div',{staticClass:"side-container__content"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }